import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "../src/assets/styles/principal/index.css";
import Header from "./assets/components/principal/header";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { LoadingProvider } from "./assets/contexts/LoadingContext";

function App() {
  return (
    <LoadingProvider>
      <Router>
        <Header />
        <ToastContainer />
      </Router>
    </LoadingProvider>
  );
}

export default App;
